module.exports = __webpack_public_path__ + "img/r-0.fbab81f.png";